import React from "react"
import styled from "styled-components"
import Slide from "react-reveal/Slide"
import LinkedInIcon from "Static/icons/linkedin.svg"

import { ActionButton, LinkBox } from "Components"

import { BrandedColor, Speakers } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.section`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem;
  }

  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: column;
    margin: 0;
    padding: 2rem;
    width: 100%;
  }

  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto 0;
  }
  max-width: ${theme.layout.base};
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: left;
  width: 100%;
  background-color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  border-color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Grid = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const Title = styled.h2`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  text-align: left;
`
const Subtitle = styled.p`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: left;
`

const Panel = ({
  tag,
  open,
  speakers,

  subtitle,

  cta_action,
  cta_action_text,
  cta_url,
  cta_text,
}) => (
  <>
    <hr />
    <Wrapper>
      <Content>
        <Slide duration={600} delay={500}>
          <>
            <Title>
              The <BrandedColor>{tag}</BrandedColor>Panel
            </Title>
            <Subtitle>{subtitle}</Subtitle>
          </>
        </Slide>
      </Content>
      <Grid>
        <Speakers.Grid>
          {speakers.map(({ firstName, lastName, company_name, title, image, linkedin_link }, i) => (
            <Speakers.Card key={i}>
              <LinkBox to={linkedin_link ? linkedin_link : ""} track={"Speakers"} title={`${firstName} ${lastName}`}>
                <Speakers.Avatar
                  background={image}
                  alt={`${firstName} ${lastName} - ${title} at ${company_name}`}
                  title={`${firstName} ${lastName} - ${title} at ${company_name}`}>
                  {linkedin_link && <Speakers.Icon src={LinkedInIcon} />}
                  <Speakers.Name>
                    {firstName} {lastName}
                  </Speakers.Name>
                </Speakers.Avatar>
              </LinkBox>
              <Speakers.Content>
                <Speakers.Details>
                  <Speakers.Company>{`${company_name}`}</Speakers.Company>
                  <Speakers.Title>{`${title}`}</Speakers.Title>
                </Speakers.Details>
              </Speakers.Content>
            </Speakers.Card>
          ))}
        </Speakers.Grid>
      </Grid>
      {open && (
        <Content>
          {cta_action && cta_action_text && (
            <ActionButton onClick={cta_action} title={cta_action_text}>
              {cta_action_text}
            </ActionButton>
          )}
          {cta_text && cta_url && (
            <ActionButton href={cta_url} title={cta_text} target="_blank">
              {cta_text}
            </ActionButton>
          )}
        </Content>
      )}
    </Wrapper>
  </>
)

export default Panel
